import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import emailjs from '@emailjs/browser';
import HomePage from "./pages/HomePage";
import SignupPage from "./pages/SignupPage";

emailjs.init('X-YPmW--t-PY41wRm'); // Reemplaza con tu Public Key

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <HomePage />
        </Route>
        {/* <Route path="/signin">
          <SigninPage />
        </Route> */}
        <Route path="/signup">
          <SignupPage />
        </Route>
        {/* <Route path="/browse">
          <BrowsePage />
        </Route> */}
      </Switch>
    </Router>
  );
}

export default App;
